import type { IconSvgObject } from './types';

const FeatherIcon: IconSvgObject = [
  ["path", { d: "M7.89462 10.1187C7.32227 10.6825 7 11.4524 7 12.2558V17H11.7442C12.5476 17 13.3175 16.6777 13.8813 16.1054L19.7785 10.1192C21.4072 8.4906 21.4072 5.85006 19.7785 4.22144C18.1499 2.59285 15.5094 2.59285 13.8808 4.22145L7.89462 10.1187Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 21L15 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 12H14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FeatherIcon;
